import Errors from './Errors';
import route from '../urlex/route';

export default class FormService {
    constructor(data) {
        this.originalData = data;
        this.isLoading = false;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    submit(type, url, view_form_errors = true) {
        this.runLoading();
        type = type.toLowerCase();
        return new Promise((resolve, reject) => {
            axios[type](url, this.data())
                .then(response => {
                    this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(errors => {

                    if(view_form_errors){
                        if (errors.response) {
                            this.onFail(errors.response.data);
                            reject(errors.response.data.errors);
                        } else {
                            this.onFail(errors);
                            reject(errors);
                        }
                    }else{
                        reject(errors);
                    }

                });
        });
    }

    post(url, params = {}) {
        return this.submit('post', route('api.' + url, params));
    }

    put(url, params = {}) {
        return this.submit('put', route('api.' + url, params));
    }

    onSuccess() {
        this.stopLoading();
    }

    onFail(errResponse) {
        this.stopLoading();

        let message = errResponse.message;
        if (errResponse.hasOwnProperty('errors')) {
            for (let error in errResponse.errors) {
                if (errResponse.errors.hasOwnProperty(error)) {
                    message += "<br /> - " + errResponse.errors[error];
                }
            }
        }

        Vue.notify({
            type: 'error',
            group: 'foo',
            title: 'Ошибка:',
            text: message,
            duration: 6000
        });
        this.errors.record(errResponse.errors);
    }

    reset() {
        for (let field in this.originalData) {
            this[field] = null;
        }

        this.errors.clear();
    }

    setData(data) {
        for (let property in data) {
            this[property] = data[property];
        }
    }

    runLoading() {
        this.isLoading = true;
    }

    stopLoading() {
        this.isLoading = false;
    }

    route(path, params = {}){
        return path +"?"+Object.entries(params)
            .map(pair => pair.map(encodeURIComponent).join('='))
            .join('&');
    }
}
